var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#16A34A",
    d: "M8.94.306c2.308-.48 4.574-.419 6.831.35 3.85 1.392 6.885 4.59 7.874 8.533l.27 1.31c.105.494.083 1.048.083 1.552.006 5.639-3.752 10.667-9.498 11.722-6.86 1.26-13.012-2.84-14.337-9.614l-.086-.527C-.533 7.887 2.515 2.29 8.238.517c.212-.065.447-.104.65-.189zm6.463 6.343c-.92.18-1.246.731-1.823 1.39l-3.148 3.721c-.334.383-.688.888-1.09 1.198-.784-.75-1.34-1.547-2.555-1.531-1.324.017-2.479 1.148-2.206 2.5l.009.048c.121.659.726 1.11 1.194 1.54l1.252 1.126c.712.587 1.69 1.518 2.68 1.437l.202-.02c.75-.077 1.314-.534 1.77-1.093l4.856-6.122c.294-.341.647-.666.89-1.045.882-1.375.05-3.006-1.565-3.15z"
  })));
};
export default SvgTick;